import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import usePageTitle from '@hooks/usePageTitle/usePageTitle';

interface ISignUpFormProps {}

const SignUpForm: FC<ISignUpFormProps> = () => {
  usePageTitle('ZlaytAI - Sign up');

  return <Navigate to="/individual-sign-up" replace />;
};

export default SignUpForm;
